import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { useSelector } from 'react-redux'
import { BorrowerHeader, Footer, Header } from 'stories/layouts'
import { FloaterTabs } from 'stories/layouts/FloaterTabs'
import { InvestorHeader } from 'stories/layouts/InvestorHeader'
import { useQueryRecord } from 'utils'

export const BaseLayout = (props: any) => {
  const { children } = props
  const auth = useSelector((state: any) => state.auth)
  const { isBorrower, isInvestor } = auth.profile

  const queryRecords: any = useQueryRecord()
  const { noHeader = false } = queryRecords

  return (
    <div className="relative bg-white overflow-hidden">
      <div className={`relative lg:w-full lg:px-2 sm:px-1 bg-white flex flex-col min-h-screen`}>
        {noHeader !== false ? null : isBorrower ? <BorrowerHeader /> : isInvestor ? <InvestorHeader /> : <Header />}
        <main className="flex-1 w-full relative mx-auto main">
          <DndProvider backend={HTML5Backend}>
            {children}
            <FloaterTabs />
          </DndProvider>
        </main>
        {noHeader !== false ? null : <Footer />}
      </div>
    </div>
  )
}
